export default __webpack_public_path__ + "static/media/eci.0659dd06.png";